import React from "react";
import { Rover, RoverStateReturn } from "reakit/Rover";
import styled from "styled-components";
import { Button } from "../Button";
import { Icon } from "../Icon";
import { style } from "../style";
import { TagContainer, TagText, TagIcon, tagActionButtonStyles } from "./BaseStyles";
import { BaseTagProps } from "./Tag";

type UserInputTagProps = BaseTagProps & {
  hideTagIcon?: boolean;
  rover?: RoverStateReturn;
  onDelete: (tag: string) => void;
};

const RemoveIcon = styled(Icon).attrs({ icon: "close", small: true })``;

const DeleteTagButton = styled(Button)`
  ${tagActionButtonStyles()}

  &:hover,
  &:active,
  &:focus {
    ${RemoveIcon} {
      color: ${style.colors.blue.dark};
    }
  }
`;

export const UserInputTag: React.FC<UserInputTagProps> = ({ children, rover, hideTagIcon, onDelete }) => {
  return (
    <TagContainer $hasActionButton $hideTagIcon={hideTagIcon} aria-label={`Tag ${children}`}>
      {!hideTagIcon && <TagIcon />}
      <TagText>{children}</TagText>
      <Rover as={DeleteTagButton} variation="tertiary" aria-label={`Delete tag ${children}`} onClick={() => onDelete(children)} {...rover}>
        <RemoveIcon />
      </Rover>
    </TagContainer>
  );
};
